import { HttpClient } from "@angular/common/http";
import { Response, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

export class BaseService 
{
    private _backendUrl: string;
    private _instanceType: string;

    get backendUrl(): string
    {
        return localStorage.getItem("backendURL");
    }
    set backendUrl(url: string)
    {
        this._backendUrl = url;
    }
    get instanceType(): string
    {
        if (this._instanceType && this._instanceType != "")
            return this._instanceType;
        else
            return localStorage.getItem("exaco-instance-type");
    }
    set instanceType(type: string)
    {
        this._instanceType = type;
    }

    // protected http: HttpClient;
    // protected httpOld: Http;

    // constructor(http: HttpClient, httpOld: Http)
    // {
    //     this.httpOld.get('assets/configuration/environment.json')
    //         .map(res => res.json())
    //         .toPromise()
    //         .then((config) =>
    //         {
    //             this.backendUrl = config.url;
    //             localStorage.setItem("backendURL", config.url);

    //             console.log(config.url)
    //             console.log(this.backendUrl);
    //         });
    // }

    constructor(){}

    protected extractData(res: any)
    {
        let body = res; //.json();
        return body;// || {};
    }
    protected handleError(error: Response | any)
    {
        // In a real world app, you might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response)
        {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${ error.status } - ${ error.statusText || '' } ${ err }`;
        }
        else
        {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }
}


// WEBPACK FOOTER //
// ./src/app/+common/contracts/base-service.contract.ts